import dayjs from 'dayjs';
import _ from 'lodash';

export const AvailableType = [
  {
    id: 'NEW ITEM',
    label: 'NEW ITEM',
    color: '#fff',
    backgroundColor: '#365576',
  },
  {
    id: 'TO SEARCH',
    label: 'TO SEARCH',
    color: '#fff',
    backgroundColor: '#f6ca00',
  },
  {
    id: 'MISSING ITEM',
    label: 'MISSING ITEM',
    color: '#fff',
    backgroundColor: '#ff001b',
  },
  {
    id: 'IN STOCK',
    label: 'IN STOCK',
    color: '#fff',
    backgroundColor: '#535252',
  },
  {
    id: 'ORDERED',
    label: 'ORDERED',
    color: '#fff',
    backgroundColor: '#00c256',
  },
  {
    id: 'READY TO BE DELIVERED',
    label: 'READY TO BE DELIVERED',
    color: '#fff',
    backgroundColor: '#00c256',
  },
  {
    id: 'DELIVERED',
    label: 'DELIVERED',
    color: '#fff',
    backgroundColor: '#008c40',
  },
  {
    id: 'CANCELLED',
    label: 'CANCELLED',
    color: '#fff',
    backgroundColor: '#ff001b',
  },
  {
    id: 'RETURNED ITEM',
    label: 'RETURNED ITEM',
    color: '#fff',
    backgroundColor: '#ff001b',
  },
  {
    id: 'STAND-BY',
    label: 'STAND-BY',
    color: '#fff',
    backgroundColor: '#ff6500',
  },
];

export const QUANTITY_TYPE = [
  'KG/KG',
  'G/GR',
  'L/LT',
  "UNITA'/UNITS",
  'PEZZI/PIECES',
  'CONFEZIONI/TUBS',
  'PEZZI/BALLS',
  'PACCHETTI/PACKETS',
  'BOX/BOXES',
  'VASCHETTE/PUNNETS',
  'MAZZI/BUNCHES',
  'TESTE/HEADS',
  'SCATOLETTE/TINS',
  'VASETTI/JARS',
  'LEAVES/FOGLIE',
  'CASSA/CASE',
  'CASSA DA 4/CASE OF 4',
  'CASSA DA 6/CASE OF 6',
  'CASSA DA 12/CASE OF 12',
  'CASSA DA 24/CASE OF 24',
  'CASSA DA 36/CASE OF 36',
];
export const QuantityType = QUANTITY_TYPE?.map((item) => ({
  id: item,
  label: item,
}));
export const HEIGHT_TABLE_ITEMS = 900;
export const TAB_TO_BE_DELIVERED = 0;
export const TAB_MANAGE_LOGBOOK = 1;
export const TAB_ORDERED = 2;
export const TAB_OVERVIEW = 3;
export const CHECK_ITEMS_MAGAZZINO = 'READY TO BE DELIVERED';
export const HEIGHT_TABLE_ITEMS_COLLAPSE = 1000;
export const INVALID_STATUS_LOGBOOK = 'DELIVERED';

export const getOptionsSuppliersLogbooks = ({
  data,
  dataWithLogbookGrouped,
}) => {
  return _.uniqBy(
    _.map(
      _.filter(
        data,
        (item) =>
          _.get(
            item,
            'attributes.id_logbook.data.attributes.status_logbook'
          ) !== INVALID_STATUS_LOGBOOK
      ),
      (item) => {
        const logbookId = _.get(item, 'attributes.id_logbook.data.id');
        const logbookStatus = _.get(
          item,
          'attributes.id_logbook.data.attributes.status_logbook'
        );

        const index = _.findIndex(dataWithLogbookGrouped, (arr) => {
          const first = _.first(arr);

          return _.get(first, 'attributes.id_logbook.data.id') === logbookId;
        });
        const supplier = _.get(
          item,
          'attributes.id_logbook.data.attributes.id_supplier.data.attributes.company_name'
        );
        const collection_delivery_date = _.get(
          item,
          'attributes.id_logbook.data.attributes.collection_delivery_date'
        );
        const collection_delivery_time = _.get(
          item,
          'attributes.id_logbook.data.attributes.collection_delivery_time'
        );
        return {
          id: supplier,
          label: `${supplier} (${collection_delivery_date ? dayjs(collection_delivery_date).format('DD-MM-YYYY') : ''} ${collection_delivery_time ? dayjs(collection_delivery_time, 'HH:mm:ss').format('HH:mm') : ''}) (${logbookStatus})`,
          id_logbook: logbookId,
          id_items:
            index !== -1
              ? _.map(dataWithLogbookGrouped[index], (item) => `${item?.id}`)
              : [],
        };
      }
    ),
    'id_logbook'
  );
};

export const STATUS_ENABLE_SEND_LOGBOOK = [
  'NEW ITEM',
  'READY TO BE DELIVERED',
  'ORDERED',
  'IN STOCK',
];
